import React from "react";
import "./App.css";
import "./styles/theme.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Cases from "./pages/Cases";
import CaseDetail from "./pages/CaseDetail";
import About from "./pages/About";
import Privacy from "./pages/Privacy";

// Client Cabinet
import ClientLogin from "./pages/client/ClientLogin";
import ClientDashboard from "./pages/client/ClientDashboard";
import ClientWardrobe from "./pages/client/ClientWardrobe";
import ClientLooks from "./pages/client/ClientLooks";
import ClientCapsules from "./pages/client/ClientCapsules";
import ClientRecommendations from "./pages/client/ClientRecommendations";
import ClientRequests from "./pages/client/ClientRequests";

// Stylist Cabinet
import StylistLogin from "./pages/stylist/StylistLogin";
import StylistDashboard from "./pages/stylist/StylistDashboard";
import StylistClientDetail from "./pages/stylist/StylistClientDetail";

// Layout wrapper to conditionally show Header/Footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isCabinetRoute = location.pathname.startsWith('/cabinet') || location.pathname.startsWith('/stylist');
  
  return (
    <>
      {!isCabinetRoute && <Header />}
      <main>{children}</main>
      {!isCabinetRoute && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            {/* Marketing Website */}
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/cases" element={<Cases />} />
            <Route path="/cases/:id" element={<CaseDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<Privacy />} />
            
            {/* Client Cabinet */}
            <Route path="/cabinet/login" element={<ClientLogin />} />
            <Route path="/cabinet" element={<ClientDashboard />} />
            <Route path="/cabinet/wardrobe" element={<ClientWardrobe />} />
            <Route path="/cabinet/looks" element={<ClientLooks />} />
            <Route path="/cabinet/capsules" element={<ClientCapsules />} />
            <Route path="/cabinet/recommendations" element={<ClientRecommendations />} />
            <Route path="/cabinet/requests" element={<ClientRequests />} />
            
            {/* Stylist Cabinet */}
            <Route path="/stylist/login" element={<StylistLogin />} />
            <Route path="/stylist" element={<StylistDashboard />} />
            <Route path="/stylist/clients/:clientId" element={<StylistClientDetail />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
